module.exports = __webpack_public_path__ + "img/HT.b8bdde5a.svg";